// extracted by mini-css-extract-plugin
module.exports = {"wrap":"lk-z","subtitle":"mk-z","contentWrap":"nk-z","imgWrap":"ok-z","heading":"pk-z","copy":"qk-z"};